/** @module config/transitionWords */

export const singleWords = [ "kvôli", "miesto", "pre", "oproti", "aj", "i", "ani", "ale", "avšak", "však", "preto", "tak", "teda",
	"hoci", "aby", "ako", "keď", "keďže", "kým", "pokiaľ", "ohľadne", "takto", "tiež ", "potom", "takže", "odtiaľ", "odteraz",
	"lebo", "akonáhle", "lenže", "okrem", "nakoľko", "pokým", "pretože", "čiže", "jednako", "doteraz", "dosiaľ", "najmä",
	"napríklad", "napr.", "napokon", "predsa", "určite", "dodatočne", "ďalej", "následne", "napriek", "hlavne", "nakoniec",
	"medzitým", "inak ", "ináč", "obdobne", "podobne", "predovšetkým", "naozaj", "spočiatku ", "najprv", "najskôr", "stručne",
	"všeobecne", "samozrejme", "pravdaže", "doposiaľ", "nielen", "než", "síce", "pričom", "až", "jednak", "zato", "nielenže",
	"ibaže", "skôr", "prv", "hoc", "namiesto", "buďto", "inakšie", "hneď", "kedykoľvek" ];

export const multipleWords = [ "ako aj", "ako i", "a tak ďalej", "a tak", "aj tak", "a jednako", "a naopak", "a predsa", "ale jednako",
	"ale predsa", "a tým", "a to", "i to", "jednako však", "predsa však", "to jest", "a preto", "i keby", "i keď", "čo aj",
	"keby aj", "pretor, aby", "odvtedy čo", "zatiar čo", "vzhľadom na to, že", "berúc do úvahy, že", "napriek tomu, že",
	"preto, aby", "za účelom", "za týmto účelom", "skôr či neskôr ", "hneď ako", "len čo", "pokiaľ ide o", "pokiaľ nie",
	"pokiaľ viem", "po prvé", "čo sa týka", "až do", "až na", "až po", "z tohto dôvodu", "z toho dôvodu", "no predsa",
	"iba ak", "ak nie", "keď nie", "tobôž nie", "pravdu povediac", "ako napríklad", "okrem toho ", "v podstate", "ako je uvedené ",
	"v každom prípade", "na rozdiel od", "v porovnaní s", "v oboch prípadoch", "stručne povedané", "inými slovami",
	"na jednej strane", "na druhej strane", "s týmto cieľom" ];

export const allWords = singleWords.concat( multipleWords );

export default allWords;

